// extracted by mini-css-extract-plugin
module.exports = {"menuItemWithIcon":"MenuItemWithIcon_menuItemWithIcon__3UJzE"};